import { makeFailure, makeSuccess, TResult, isLoaded, getSgApiService } from "../../../../sg-core";
import { useAuthentication } from "../../auth/store/authSelectors";
import IObservation from "../../interfaces/IObservation";
import { EObservationPackageVersio, IObservationPackage } from "../../interfaces/ObservationPackage/ObservationPackage";
import IFormType from "../../interfaces/IFormType";
import { useFormTypeList } from "../../store/selectors/formSelectors";
import { useCategoryList } from "../../store/selectors/categorySelectors";
import ICategory from "../../interfaces/ICategory";



export const makeObservationPacakge = (data: { observation: IObservation; formType?: IFormType; category?: ICategory; }): IObservationPackage => {
    const packageData: IObservationPackage = {
        versio: EObservationPackageVersio.v1,
        observation: data.observation,
        formType: data.formType || {} as any,
        category: {} as any
    };

    return packageData
}




interface IUseGetObservationData {
    makePackage: (data: { observation: IObservation; }) => Promise<TResult<Readonly<IObservationPackage>>>;
};

export type IUseMakeObservationPackageHook = () => IUseGetObservationData;

/**
 * Hook that fetches permit and all relation data, and composes data package out of it
 */
export const useMakeObservationPackage: IUseMakeObservationPackageHook = () => {
    const { token, anonymousSession } = useAuthentication();

    const apiService = getSgApiService("");
    apiService.setToken(token || "");

    const formTypes = useFormTypeList();
    const categories = useCategoryList();

    const makePackage: IUseGetObservationData["makePackage"] = async ({ observation }) => {
        try {

            const formType = formTypes && isLoaded(formTypes) ? formTypes.data.find((form) => form.id === observation.formType) : undefined;
            const category = categories && isLoaded(categories) ? categories.data.find((category) => category.id === formType?.category) : undefined;
            const packageData: IObservationPackage = makeObservationPacakge({
                observation,
                formType,
                category
            });


            return makeSuccess(packageData);
        } catch (error) {
            console.info(error);
            return makeFailure(error as Error);
        };
    };

    return {
        makePackage
    };
};
